import React from "react";
import CategoryIcon from "@mui/icons-material/Category";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import StarIcon from "@mui/icons-material/Star";
import Avatar from "@mui/material/Avatar";
import renderCellExpand from "components/GridCellExpand";

export const getColumns = () => [
  {
    field: "image",
    headerName: "Imagem",
    cellClassName: "logo--cell",
    renderCell: ({ value, row }) => {
      return (
        <Avatar src={value} alt={row.name} variant="rounded">
          <CategoryIcon />
        </Avatar>
      );
    },
  },
  {
    field: "name",
    headerName: "Nome",
    renderCell: renderCellExpand,
    flex: 1,
    editable: true,
  },
  {
    field: "slug",
    headerName: "Slug Principal",
    flex: 1,
    editable: true,
  },
  {
    field: "description",
    headerName: "Descrição",
    renderCell: renderCellExpand,
    flex: 1,
    editable: true,
    sortable: false,
  },
  {
    field: "is_popular",
    renderHeader: () => <StarIcon />,
    description: "É Popular?",
    type: "boolean",
    editable: true,
    sortable: false,
    flex: 0.3,
  },
  {
    field: "weight",
    renderHeader: () => <FitnessCenterIcon />,
    description: "Peso",
    type: "number",
    editable: true,
    sortable: false,
    flex: 0.3,
  },
];
